import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IGamesState, IGame } from "./types";
import {
  fetchGetGamesList,
  fetchGetAppliedGames,
  fetchGetCreatedGames,
  fetchCreateGame,
  fetchApplyGame,
  fetchDeleteGame,
  fetchCancelApplication,
  fetchGetApplicationsCount,
} from "./asyncActions";

const initialState: IGamesState = {
  gamesLoading: false,
  games: [],
  appliedGames: [],
  createdGames: [],
  applicationsCount: 0,
};

const gamesSlice = createSlice({
  name: "games",
  initialState,
  reducers: {
    setGamesLoading(state, action: PayloadAction<boolean>) {
      state.gamesLoading = action.payload;
    },
    setGames(state, action: PayloadAction<IGame[]>) {
      state.games = action.payload;
    },
    setAppliedGames(state, action: PayloadAction<IGame[]>) {
      state.appliedGames = action.payload;
    },
    setCreatedGames(state, action: PayloadAction<IGame[]>) {
      state.createdGames = action.payload;
    },
    addMyGame(state, action: PayloadAction<IGame>) {
      state.createdGames.push(action.payload);
    },
    addAppliedGame(state, action: PayloadAction<IGame>) {
      state.appliedGames.push(action.payload);
    },
    deleteMyGame(state, action: PayloadAction<number>) {
      state.createdGames = state.createdGames.filter(
        (game) => game.id !== action.payload
      );
    },
    cancelAppliedGame(state, action: PayloadAction<number>) {
      state.appliedGames = state.appliedGames.filter(
        (game) => game.id !== action.payload
      );
    },
    setApplicationsCount(state, action: PayloadAction<number>) {
      state.applicationsCount = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchGetGamesList.pending, (state) => {
        // Не устанавливаем loading здесь, так как он устанавливается вручную перед всеми запросами
      })
      .addCase(fetchGetGamesList.fulfilled, (state, action) => {
        // Не сбрасываем loading здесь, так как могут быть другие запросы
        // Данные устанавливаются через actions
      })
      .addCase(fetchGetGamesList.rejected, (state) => {
        state.gamesLoading = false;
      })
      .addCase(fetchGetAppliedGames.fulfilled, (state, action) => {
        state.appliedGames = action.payload;
        // После завершения всех запросов loading будет сброшен вручную
      })
      .addCase(fetchGetAppliedGames.rejected, (state) => {
        state.gamesLoading = false;
      })
      .addCase(fetchGetCreatedGames.fulfilled, (state, action) => {
        state.createdGames = action.payload;
        // После завершения всех запросов loading будет сброшен вручную
      })
      .addCase(fetchGetCreatedGames.rejected, (state) => {
        state.gamesLoading = false;
      })
      .addCase(fetchCreateGame.fulfilled, (state, action) => {
        state.createdGames.push(action.payload);
      })
      .addCase(fetchDeleteGame.fulfilled, (state, action) => {
        state.createdGames = state.createdGames.filter(
          (game) => game.id !== action.payload
        );
      })
      .addCase(fetchCancelApplication.fulfilled, (state, action) => {
        state.appliedGames = state.appliedGames.filter(
          (game) => game.id !== action.payload
        );
      })
      .addCase(fetchGetApplicationsCount.fulfilled, (state, action) => {
        state.applicationsCount = action.payload.count || 0;
      });
  },
});

export const {
  setGamesLoading,
  setGames,
  setAppliedGames,
  setCreatedGames,
  addMyGame,
  addAppliedGame,
  deleteMyGame,
  cancelAppliedGame,
  setApplicationsCount,
} = gamesSlice.actions;

export default gamesSlice.reducer;
